import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { emitLeadManagementPageViewEvent } from '../constants/clickstreamEvents/pageView';
import type { ZrmClickstreamUserOrNull } from '../analytics/types';

// Emits the page-view event once per mount, waiting for router.isReady so deep links
// carry the resolved alias instead of '' (router.query is empty on first render).
export default function useEmitLeadManagementPageView(user: ZrmClickstreamUserOrNull, listingAlias: string) {
  const router = useRouter();
  const hasEmittedRef = useRef(false);

  useEffect(() => {
    if (!router.isReady || hasEmittedRef.current) return;
    hasEmittedRef.current = true;
    emitLeadManagementPageViewEvent(user, { listingAlias });
  }, [router.isReady, user, listingAlias]);
}
